<template>

  <section class="container">
    <h1>Neuen Firma hinzufügen</h1>

    <form @submit.prevent="saveContact">

    <div class="columns">
      <div class="column">

      <div class="field">
        <div class="control control-100">
          <input class="input" type="text" placeholder="Firma" v-model="company" required>
        </div>
      </div>

      <div class="field">
        <div class="control control-100">
          <input class="input" type="text" placeholder="Straße und Nr." v-model="address" required>
        </div>
      </div>


      <div class="field">
        <div class="control control-50">
          <input class="input" type="text" placeholder="Postleitzahl" v-model="zipcode" required>
        </div>
        <div class="control control-50">
          <input class="input" type="text" placeholder="Stadt" v-model="city" required>
        </div>
      </div>



      <div class="field">
        <div class="control control-100">
          <input class="input" type="email" placeholder="E-Mail Adresse" v-model="emailaddress" required>
        </div>
      </div>

      <div class="field">
        <div class="control control-50">
          <input class="input" type="text" placeholder="Telefon" v-model="phonenumber" required>
        </div>
        <div class="control control-50">
          <input class="input" type="text" placeholder="Fax" v-model="faxnumber" required>
        </div>
      </div>


      <div class="field">
        <div class="control control-100">
          <input class="input" type="text" placeholder="Land" v-model="country" required>
        </div>
      </div>


      <div class="field">
        <div class="control">
          <button type="submit" class="button is-link">Speichern</button>
        </div>
      </div>


      </div>
    </div>
    </form>
  </section>
  
</template>
<script>
import firebase from 'firebase'
  
export default {
  name: 'NewContact',
  data: function(){ 
    return {
          company: null,
          address: null,
          zipcode: null,
          city: null,
          emailaddress: null,
          phonenumber: null,
          faxnumber: null,
          country: null,
    }
  },
  methods: {
        saveContact () {
          firebase.firestore().collection('clients').add({
            company: this.company,
            emailaddress: this.emailaddress,
            phonenumber: this.phonenumber,
            faxnumber: this.faxnumber,
            zipcode: this.zipcode,
            city: this.city,
            address: this.address,
            country: this.country,
            slug: this.generateUUID()
          })
            .then(function (docRef) {
              console.log('Document written with ID: ', docRef.id)
            })
            .catch(function (error) {
              console.error('Error adding document: ', error)
            })
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        }
  }  
}  
</script>
<style>
  .field { display: flex; padding: 0; }
  .control { padding: 0.43333333em; }
  .control-50 { flex: 1 1 50%; width: 50%; max-width: 50%; }
  .control-100 { flex: 0 0 100%; width:100%; max-width: 100%; }
  .control input[type=text] { width: 100%; margin: 0; }
  .control input[type=email] { width: 100%; margin: 0; }
</style>


// WEBPACK FOOTER //
// src/components/NewCompany.vue